
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/cafes/search-results",
      function () {
        return require("private-next-pages/[region]/[lang]/cafes/search-results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/cafes/search-results"])
      });
    }
  